export default __webpack_public_path__ + "static/6-679b0ce2a161b3e853abc8866dce2f24.jpg";